import { OrderAPI } from '@/api';
import { IApiError } from '@/models/apiError.model';
import {
  IGetOrdersDTO,
  IGetOrdersResponse,
  IChangeOrderStatusDTO,
  TChangeOrderStatusResponse,
  IGetOrderResponse,
  IUploadFilesDTO,
  IDeleteFilesDTO,
  TDeleteFilesResponse,
  TUploadFilesResponse,
  ICompleteOrderDTO,
  TCompleteOrderResponse,
  IUpdateAppraisalOrderDTO,
} from '@/models/order.model';
import { formatApiError } from '@/utils';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { ORDERS_SLICE_NAME } from './models';

export const getOrders = createAsyncThunk<IGetOrdersResponse, IGetOrdersDTO, { serializedErrorType: IApiError }>(
  `${ORDERS_SLICE_NAME}/getOrders`,
  async (data) => {
    const response = await OrderAPI.getOrders(data);
    return response.data;
  },
  { serializeError: formatApiError },
);

export const getOrder = createAsyncThunk<IGetOrderResponse, string, { serializedErrorType: IApiError }>(
  `${ORDERS_SLICE_NAME}/getOrder`,
  async (id) => {
    const response = await OrderAPI.getOrder(id);
    return response.data;
  },
  { serializeError: formatApiError },
);

export const changeOrderStatus = createAsyncThunk<
  TChangeOrderStatusResponse,
  IChangeOrderStatusDTO,
  { serializedErrorType: IApiError }
>(
  `${ORDERS_SLICE_NAME}/changeOrderStatus`,
  async (data) => {
    const response = await OrderAPI.changeOrderStatus(data);
    return response.data;
  },
  { serializeError: formatApiError },
);

export const addFilesToOrder = createAsyncThunk<
  TUploadFilesResponse,
  IUploadFilesDTO,
  { serializedErrorType: IApiError }
>(
  `${ORDERS_SLICE_NAME}/uploadOrderFiles`,
  async (data) => {
    const response = await OrderAPI.uploadOrderFiles(data);
    return response.data;
  },
  { serializeError: formatApiError },
);

export const deleteOrderFiles = createAsyncThunk<
  TDeleteFilesResponse,
  IDeleteFilesDTO,
  { serializedErrorType: IApiError }
>(
  `${ORDERS_SLICE_NAME}/deleteOrderFiles`,
  async (data) => {
    const response = await OrderAPI.deleteOrderFiles(data);
    return response.data;
  },
  { serializeError: formatApiError },
);

export const completeOrder = createAsyncThunk<
  TCompleteOrderResponse,
  ICompleteOrderDTO,
  { serializedErrorType: IApiError }
>(`${ORDERS_SLICE_NAME}/completeOrder`, async (data) => {
  const response = await OrderAPI.completeOrder(data);
  return response.data;
});

export const updateAppraiserOrder = createAsyncThunk<
  IGetOrderResponse,
  IUpdateAppraisalOrderDTO,
  { serializedErrorType: IApiError }
>(`${ORDERS_SLICE_NAME}/completeOrder`, async (data) => {
  const response = await OrderAPI.updateAppraiserOrder(data);
  return response.data;
});
